<template>
    <header class="sticky top-0 z-40 bg-paper/85 backdrop-blur-md">
        <div class="container-page flex h-[72px] items-center justify-between">
            <router-link to="/" class="flex items-center gap-3" @click="mobileMenuVisible = false">
                <img src="/images/ege.webp" alt="" class="h-9 w-9 rounded-full object-cover" />
                <span class="font-display text-[17px] font-semibold tracking-tight text-ink">Ege Arslan</span>
            </router-link>

            <!-- Desktop Navigation -->
            <nav class="hidden md:flex items-center gap-1 rounded-full border border-line bg-surface p-1 text-[14px]">
                <router-link v-for="item in menuItems" :key="item.key" :to="item.to" :class="[
                    'rounded-full px-4 py-1.5 transition-colors',
                    currentPage === item.key ? 'bg-ink text-white' : 'text-ink-2 hover:text-ink hover:bg-surface-2'
                ]">
                    {{ item.label }}
                </router-link>
            </nav>

            <a href="mailto:ege.arslan.dev@gmail.com" class="hidden md:inline-flex btn-ghost !py-2">
                Contact
            </a>

            <!-- Mobile Menu Button -->
            <button class="md:hidden flex h-10 w-10 items-center justify-center rounded-full border border-line bg-surface"
                :aria-expanded="mobileMenuVisible" aria-label="Menu" @click="toggleMobileMenu">
                <i :class="mobileMenuVisible ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'" class="text-[15px] text-ink"></i>
            </button>
        </div>

        <!-- Mobile Menu -->
        <div v-if="mobileMenuVisible" class="md:hidden container-page pb-4">
            <nav class="card flex flex-col p-2">
                <router-link v-for="item in menuItems" :key="item.key" :to="item.to" :class="[
                    'rounded-2xl px-4 py-3 text-[16px]',
                    currentPage === item.key ? 'bg-surface-2 text-ink font-medium' : 'text-ink-2'
                ]" @click="mobileMenuVisible = false">
                    {{ item.label }}
                </router-link>
                <a href="mailto:ege.arslan.dev@gmail.com" class="rounded-2xl px-4 py-3 text-[16px] text-accent">Contact</a>
            </nav>
        </div>
    </header>
</template>

<script>
export default {
    props: {
        currentPage: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            mobileMenuVisible: false,
            menuItems: [
                { label: 'Home', to: '/', key: 'home' },
                { label: 'Mobile Apps', to: '/mobile-apps', key: 'mobile-apps' },
                { label: 'Projects', to: '/projects', key: 'projects' }
            ]
        };
    },
    methods: {
        toggleMobileMenu() {
            this.mobileMenuVisible = !this.mobileMenuVisible;
        }
    }
};
</script>
